import ProfileAssessmentGetStartedPage from '@/presentation/pages/profile-assessment/get-started-page'

export const makeProfileAssessmentGetStartedPage = () => <ProfileAssessmentGetStartedPage />
